import {
  CHANGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE,
  RESTORE_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE,
  DEFAULT_LODGINGS_AND_RESERVATIONS_FILTER_STATE,
  LodgingsAndReservationsFilterActionTypes,
  LodgingsAndReservationsFilterState,
  NEXT_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE
} from "./types";

const defaultState: LodgingsAndReservationsFilterState = {
  miles: 60,
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
  page: 1,
  lodgingsWithRoomsOnly: false,
};

export default function lodgingsAndReservationsFilter(state = defaultState, action: LodgingsAndReservationsFilterActionTypes): LodgingsAndReservationsFilterState {
  switch (action.type) {
    case CHANGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE:
      return {
        coords: action.coords ?? state.coords,
        miles: action.miles ?? state.miles,
        fromDate: action.fromDate ?? state.fromDate,
        toDate: action.toDate ?? state.toDate,
        page: action.page ?? state.page,
        lodgingsWithRoomsOnly: action.lodgingsWithRoomsOnly ?? state.lodgingsWithRoomsOnly
      };
    case RESTORE_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE:
      return {
        miles: action.miles ?? state.miles,
        fromDate: action.fromDate ?? state.fromDate,
        toDate: action.toDate ?? state.toDate,
        page: 1,
        lodgingsWithRoomsOnly: action.lodgingsWithRoomsOnly ?? state.lodgingsWithRoomsOnly
      };
    case DEFAULT_LODGINGS_AND_RESERVATIONS_FILTER_STATE:
      return defaultState;
    case NEXT_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE:
      return {...state, page: state.page + 1};
    default:
      return state;
  }
}